import { MetaTags } from './MetaTags';
import { JsonLd } from './JsonLd';
import { generateMetadata } from '../../lib/seo/metadata';
import { Helmet } from 'react-helmet-async';
import { siteUrl } from '../../lib/seo/site-url';

interface SeoHeadProps {
  route: string;
  lang: 'pt-BR' | 'en-US';
  title: string;
  description: string;
  image?: string;
  noindex?: boolean;
}

export function SeoHead({ route, lang, title, description, image, noindex }: SeoHeadProps) {
  const jsonLdData = generateMetadata(route, lang);
  const canonicalUrl = siteUrl(route);

  if (noindex) {
    return (
      <>
        <MetaTags title={title} description={description} canonical={canonicalUrl} image={image} />
        <Helmet>
          <html lang={lang} />
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      </>
    );
  }

  return (
    <>
      <MetaTags title={title} description={description} canonical={canonicalUrl} image={image} />
      {jsonLdData && <JsonLd data={jsonLdData} />}
      <Helmet>
        <html lang={lang} />
        <link rel="alternate" hrefLang="pt-BR" href={canonicalUrl} />
        <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />
      </Helmet>
    </>
  );
}
